import 'promise-decode-audio-data';

import Stars from '../components/Stars';

import init from './init';

init.Tracking();

const is404 = document.getElementById('Error404');

if (is404) {
  is404.appendChild(Stars());
} else {
  // not running serviceWorker on 404 before of absolute URLS...
  // this may indicate that I should simply always use absolute URLs in production?
  init.ServiceWorker();
  init.Draggables();
  init.Features();
  init.Audio();
}
